export default "__VITE_ASSET__CKlZ5TDK__"